import { useMemo } from 'react';
import { useLanguage } from './useLanguage';

export const useLocale = (labels: Record<string, string>) => {
    const { t, language } = useLanguage();

    const _labels = useMemo(() => {
        const translation: Record<string, string> = {};

        Object.entries(labels).forEach(([label, value]) => {
            translation[label] = t(value);
        });

        return translation;
    }, [language]);

    return _labels;
};
